<template>
<div class="loh-chart-group">
  <x-y-chart
    :data-config="dataConfig"
    :unit-prop="unitProp"
    :chart-type="chartType"
    :stack-type="stackType"
    download-name="Lᴼᴴ"
    :show-selected-ctrl-btn="false"
    :is-show-line="true"
    :show-legend="false"
    :click-handler="onLOHItemClick"
    need-resize
    chart-height="auto"
  />

  <div class="iloh-chart-container">
    <e-chart ref="iloh-chart" @initialized="onIlohChartInitialized" @destroy="onIlohChartDestroy" />
  </div>
</div>
</template>

<script>
import BaseStore from '../../../../components/BaseStore'
import ChartStyle from '../../../../components/DataChart/ChartStyle'

import XYChart from '../../../../components/DataChart/XYChart'
import EChart from '../../../../components/Charts/ECharts'

export default {
  name: 'LohChartGroup',
  extends: BaseStore,
  components: {XYChart, EChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    hourAvgIlohData: {
      required: true
    },
    unitProp: {
      required: true,
      type: String
    },
    top: {
      required: true
    },
    isAuditCompleted: {
    },
    isMultipleIntegral: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    chartType: 'bar',
    stackType: 1
  }),
  computed: {
    unit () {
      return this.dataConfig.unit
    }
  },
  methods: {
    renderILOHChart (ilohData) {
      let {iloh} = ilohData
      let {factorMap} = this
      let chartOpt = {
        title: {
          text: ilohData.title,
          left: 'center',
          textStyle: {
            fontFamily: ChartStyle.TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          formatter: function (param) {
            let {data, marker, value, seriesName, name} = param[0]
            return `<div style="min-width: 130px;">
              <span style="display: inline-block; margin: 3px; font-weight: bold;">${name}${(data && data.isHaveIntegral) ? '(重积分)' : ''}</span>
              <div style="display: flex;justify-content: space-between;align-items: center;padding: 2px;">
                <span>${marker}${seriesName}</span>
                <span><span style="font-weight: bold;">${value}</span></span>
              </div>
            </div>`
          }
        },
        grid: [{
          top: 40,
          right: 40,
          bottom: 45,
          left: 0,
          containLabel: true
        }],
        xAxis: [{
          type: 'value',
          name: this.unit,
          nameLocation: 'center',
          nameGap: 23,
          axisLine: {
            show: true
          },
          axisLabel: {
            fontSize: ChartStyle.FONT_SIZE,
            fontFamily: ChartStyle.NUMBER_FONT_FAMILY
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'category',
          data: iloh.map(data => factorMap[data.factorId].name),
          inverse: true,
          axisLine: {
            show: true
            // lineStyle: AXIS_LINE_STYLE
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            fontSize: ChartStyle.FONT_SIZE,
            fontFamily: ChartStyle.TEXT_FONT_FAMILY
          }
        },
        series: [{
          name: 'Lᴼᴴ',
          type: 'bar',
          barMaxWidth: 30,
          data: iloh.map(el => {
            return {
              isHaveIntegral: el.isHaveIntegral || false,
              value: Number.isFinite(el.iloh) ? Number(el.iloh.toFixed(3)) : el.iloh
            }
          }),
          color: '#9a60b4',
          label: {
            show: true,
            position: 'insideLeft'
          }
        }]
      }

      let ilohChart = this.$refs['iloh-chart']
      ilohChart.resize()
      ilohChart.setOpt(chartOpt)
    },
    onLOHItemClick (param) {
      this.changeLoadStatus(true)

      let {dataTime} = param.data

      this.$api.Data.getStatisticAnalysisILOH(this.dataConfig.id, {
        dataTime,
        isAuditCompleted: this.isAuditCompleted,
        isMultipleIntegral: this.isMultipleIntegral,
        unit: this.unit,
        num: Number(this.top)
      }).then(dataList => {
        this.renderILOHChart({
          title: new Date(dataTime).format('YYYY-MM-DD HH'),
          iloh: dataList
        })
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onIlohChartInitialized () {
      this.initialized = true

      let {hourAvgIlohData} = this

      if (hourAvgIlohData) {
        this.renderILOHChart(hourAvgIlohData)
      }
    },
    onIlohChartDestroy () {
      this.initialized = false
    }
  },
  watch: {
    hourAvgIlohData (hourAvgIlohData) {
      if (hourAvgIlohData && this.initialized) {
        this.renderILOHChart(hourAvgIlohData)
      }
    }
  }
}
</script>

<style lang="scss">
.loh-chart-group {
  display: grid;
  grid-template-columns: auto 38%;
  grid-column-gap: 10px;
  flex: 1 0;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/02ReactivityAnalysis/LohChartGroup.vue